import { TSortParams } from '../types/tableTypes';

type CommonFilterType<T> = T | null | undefined;

export class BaseFilter<ValueType> {
  protected name: string;
  protected value: CommonFilterType<ValueType>;

  constructor({ name }: { name: string }) {
    this.name = name;
  }

  getName() {
    return this.name;
  }

  setValue(value: CommonFilterType<ValueType>) {
    this.value = value;
  }

  getValue(): CommonFilterType<ValueType> {
    return this.value;
  }

  resetValue() {
    this.value = null;
  }

  toEntries(): Array<[string, string]> | null | undefined {
    throw new Error('Method `toEntries` should be implemented for value: ' + this.value);
  }
}

export type PaginationFilterType = {
  size?: number | null | undefined;
  number?: number | null | undefined;
};

export class PaginationFilter extends BaseFilter<PaginationFilterType> {
  static sizeFieldName = 'pageSize';

  static numberFieldName = 'pageNumber';

  toEntries() {
    if (this.value === null || this.value === undefined) {
      return null;
    }
    const entries = [] as Array<[string, string]>;
    if (this.value.size !== undefined && this.value.size !== null) {
      entries.push([PaginationFilter.sizeFieldName, String(this.value.size)]);
    }
    if (this.value.number) {
      entries.push([PaginationFilter.numberFieldName, String(this.value.number)]);
    }
    return entries;
  }
}

export class SortFilter extends BaseFilter<TSortParams> {
  static columnFieldName = 'sortColumn';

  static orderFieldName = 'sortOrder';

  toEntries() {
    if (this.value === null || this.value === undefined) {
      return null;
    }
    const column = [SortFilter.columnFieldName, this.value.sortColumn] as [string, string];
    const order = [SortFilter.orderFieldName, this.value.sortOrder] as [string, string];
    return [order, column];
  }
}
